module.exports = __webpack_public_path__ + "img/project1_3.png.bf4c4534.webp";